import { Dropdown, Menu, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { URCheckBox } from "../../../shared/widgets/checkBoxForCall";
import { URInput } from "../../../shared/widgets/input";
import CallMainWindowTeam from "./callMainWindowTeam";
import styles from "./../scss/callsFrame.module.scss";
import { automatedMintsStore, update_Mic_Language } from "../../../base/callService/store_mining";
//import { currentCallEnd } from "../../../base/callService/callService";
import { altRecTimer, asrSearchLanguage, audioLanguageChange,   findCallHost,   findTileSize, frameCallProfile, getCurrentCallDetail, toastInformation } from "../../../base/callService/common";
import { userUpdateAsrLang } from "../../../base/callService/callsApiService";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { calldetail, callMainWindowState, closeCaptionmeetingState } from "../../../models/callModel";
import store from "../../../context/store/store";
import { sendDTMF } from "../../../base/callService/callService";
import { contacts, LoginState,UserDetails} from "../../../models/model";
import teamIcn from "../../../styles/images/teamimg.svg";




// import { config } from "../../../base/constant";
// import directTransferImg from "../../../styles/images/transfer1.svg";
// import consultTransferImg from "../../../styles/images/transfer2.svg";

//import { UserDetails } from "../../../models/model";


type propsTypes = {
  dialpadUI?: any;
  callDetail: calldetail[];

};
type stateTypes = {
  isAddCall: boolean,
  isKeyPad: boolean,
  ifFlipKey: string,
  mic_Search: string,
  spec_Search: string,
  transferType: string,
  open_ASR_mic: boolean,
  isModalVisible: boolean,
  isFlippedDevice: string,
  isTransferPopup: boolean,
  open_ASR_speaker: boolean,
};
function DiallingWindow({ callDetail }: propsTypes) {
  let history = useHistory();
  const [state, setState] = useState<stateTypes>
    ({
      isAddCall: false, isKeyPad: false, isModalVisible: false,
      isFlippedDevice: '', ifFlipKey: '', mic_Search: '', spec_Search: '',
      transferType: '', open_ASR_mic: false, open_ASR_speaker: false, isTransferPopup: false
    });

  const { updatedCallList }: callMainWindowState
    = useSelector((state: callMainWindowState) => state);

  //let { flipDeviceInfo } = callPermissionDetail || [];
  let activeCallDetail: any = getCurrentCallDetail()||{};
  let isActiveCheck: string = updatedCallList.rightSideWindow || '';
  let updatedCallRedux: calldetail[] = updatedCallList.callDetails || [];
  let closeCaption: closeCaptionmeetingState = store.getState().closeCaption || [];
  let {transcriptEnable}=store.getState().closeCaption;
  let { teamContacsnew }: contacts = store.getState().contactReducer || [];
  
  // let { groupcallCount } = store.getState().callReducer || {};



  //const openKeypad = () => { setState({ ...state, isKeyPad: !state.isKeyPad }); };

  // let {groupCallInfo}=activeCallDetail;
  // const addAnotherCall = () => {
  //   setState({ ...state, isAddCall: true });
  //   if (dialpadUI) {
  //     dialpadUI();
  //   }
  // };

  // const callFlip = () => {
  //   setState({
  //     ...state, isModalVisible: !state.isModalVisible,
  //     isFlippedDevice: '', ifFlipKey: ''
  //   });
  // };

  // const callPark = () => {
  //   sendDTMF('*88#');
  //   //toastShow("Your call parked at location 701");
  // };

  // const setTranscribe = () => {
  //   setState({ ...state, open_ASR_speaker: !state.open_ASR_speaker });
  // };

  // const transferCall = (option: string) => {
  //   setState({ ...state, isAddCall: true, transferType: option, isTransferPopup: false });
  //   if (dialpadUI) {
  //     dialpadUI();
  //   }
  // }

  // const contactListHide = () => {
  //   setState({ ...state, isAddCall: false });
  //   if (dialpadUI) { dialpadUI(); }
  // };

  // const selectedContactList = (ext: string, selectedContactName: string) => {
  //   if (ext !== "" && check_Ext_valid(ext)) {

  //     if (state.transferType !== '') {
  //       if (state.transferType === 'blind') {
  //         callTransfer(ext);
  //         toastShow(config().CALL_TRANSFER);
  //       }
  //       else { initiateCall(ext, 'audio', 'consult'); }
  //       setState({ ...state, isAddCall: false, transferType: '' });
  //       if (dialpadUI) { dialpadUI(); }
  //     }
  //     else {
  //       initiateCall(ext, 'audio');
  //       setState({ ...state, isAddCall: false });
  //       toastShow(config().ADD_CALL + " " + selectedContactName);
  //     }
  //   }
  //   else { toastShow("Please check the number"); }
  //   if (dialpadUI) {
  //     dialpadUI();
  //   }
  // };

  // const attendedCallTransferOpt = () => {
  //   attendedCallTransfer();
  //   toastShow(config().CALL_TRANSFER);
  // };

  // const toastShow = (message: string, timer?: number) => {
  //   if (history.location.pathname === '/calls' && !updatedCallList.minimizedWindow) { toastMessageCallWindow(message, timer); }
  //   else { toastInformation(message, "success"); }
  // };

  // const callFlipped = () => {
  //   if (state.ifFlipKey) {
  //     sendDTMF(state.ifFlipKey);
  //     let deviceType: string = '';
  //     deviceType = (state.isFlippedDevice === config().DESK_PHONE) ? 'Desk Phone' :
  //       (state.isFlippedDevice === config().UR_ANDROID) ? 'Android' : 'IOS';
  //     toastShow("Call flip to " + deviceType + " Device");
  //   }
  //   setState({
  //     ...state, isModalVisible: !state.isModalVisible,
  //     isFlippedDevice: '', ifFlipKey: ''
  //   });
  // };

  // const flipDeviceChecked = (status: string, key: string) => {
  //   setState({ ...state, isFlippedDevice: status, ifFlipKey: key });
  // };

  const updateInputLanguage = (lanChar: string) => {
    update_Mic_Language(lanChar);
    setState({ ...state, open_ASR_mic: false });
    audioLanguageChange(lanChar, activeCallDetail.guid);
  };

  // const updateOutputLanguage = (lanChar: string) => {
  //   update_Spec_Language(lanChar);
  //   setState({ ...state, open_ASR_speaker: false });
  //   if (lanChar === 'en' || lanChar === 'es' || lanChar === 'fr') {
  //     (lanChar === 'en' ? volumeDecrease(1) : volumeDecrease(0));
  //     outputLanguageChange(lanChar, activeCallDetail.guid);
  //   }
  // };
  const textBoxMicOnchange = (keyPress: any) => {
    setState({ ...state, mic_Search: keyPress.target.value });
  };

  // const textBoxSpecOnchange = (keyPress: any) => {
  //   setState({ ...state, spec_Search: keyPress.target.value });
  // };

  // const callRecordStartStop = () => {
  //   if (activeCallDetail['onDemand'] === true || activeCallDetail['autoRecord'] === true) {
  //     (activeCallDetail['recordState']) ? toastShow('Call recorded stopped') : toastShow('Call recording started');
  //     sendDTMF("*9");
  //     callrecording();
  //   }
  //   else { toastShow('Please enable recording option in my account...'); }
  // };
  // const consultTransferDropDown = (
  //   <div className={styles.transferpops}>
  //     <ul>
  //       <li onClick={() => transferCall('blind')}>
  //         <img src={directTransferImg} alt="" />Direct Call Transfer</li>
  //       <li onClick={() => transferCall('consult')}>
  //         <img src={consultTransferImg} alt="" />Attend Call Transfer</li>
  //     </ul>
  //   </div>
  // );

  let ASR_Data: any = store.getState().ASR_Language || [];
  let asrMicLanguage = asrSearchLanguage(ASR_Data.list, state.mic_Search);
  //let asrSpecLanguage = asrSearchLanguage(ASR_Data.list, state.spec_Search);
  let ast_default_Mic_Opt = ASR_Data.asr_mic_lan || 'en';
  let ast_default_Spe_Opt = ASR_Data.asr_speaker_lan || 'en';

  const inputLangSelection = (
    <div className={styles.autoTranslateLangs}>
      <h3>Speaking Language</h3>
      <div className={styles.searchBox}><URInput placeHolder='Search'
        className='searchBoxlanglist' onChange={textBoxMicOnchange} /></div>
      <ul className={`scroller ${styles.langList}`}>
        {asrMicLanguage.map((elem: any, index: number) => {
          return (<li key={index} className={ast_default_Mic_Opt === elem.languageCode ? `${styles.selected} ${styles.active}` : styles.selected}
            onClick={() => updateInputLanguage(elem.languageCode)}>
            <span className={ast_default_Mic_Opt === elem.languageCode ? `icon_tick  ltick` : 'icon_tick'}></span>
            {elem.languageName + " (" + elem.languageCode + ")"}</li>);
        })
        }
      </ul>
      <div className={`customchecksize ${styles.bottomFooterSec}`}>
        <URCheckBox onChange={(e: any) => update_ASR_Language(e)} />
        <span className={styles.saveTxttop}>Save for future</span>
      </div>
    </div>
  );

  // const outPutLangSelection = (
  //   <div className={styles.autoTranslateLangs}>
  //     <h3>Audio Translation Language</h3>
  //     <div className={styles.searchBox}><URInput placeHolder='Search'
  //       className='searchBoxlanglist' onChange={textBoxSpecOnchange} /></div>
  //     <ul className={`scroller ${styles.langList}`}>
  //       {asrSpecLanguage.map((elem: any, index: number) => {
  //         return (<li key={index} className={ast_default_Spe_Opt === elem.languageCode ? `${styles.selected} ${styles.active}` : styles.selected}
  //           onClick={() => updateOutputLanguage(elem.languageCode)}>
  //           <span className={ast_default_Spe_Opt === elem.languageCode ? `icon_tick  ltick` : 'icon_tick'}></span>
  //           {elem.languageName + " (" + elem.languageCode + ")"}</li>);
  //       })
  //       }
  //     </ul>
  //     <div className={`customchecksize ${styles.bottomFooterSec}`}>
  //       <URCheckBox onChange={(e: any) => update_ASR_Language(e)} />
  //       <span className={styles.saveTxttop}>Update in My Profile Settings</span>
  //     </div>
  //   </div>
  // );

  const update_ASR_Language = (e: any) => {
    if (e.target.checked) {
      let data: any = {
        languageCode: (state.open_ASR_mic) ? ast_default_Mic_Opt : ast_default_Spe_Opt
      };
      userUpdateAsrLang(data);
    }
    setState({ ...state, open_ASR_mic: false, open_ASR_speaker: false });
  };
  // const handle_Mic_VisibleChange = (flag: any) => {
  //   setState({ ...state, open_ASR_mic: flag });
  // };
  // const handle_Spec_VisibleChange = (flag: any) => {
  //   setState({ ...state, open_ASR_speaker: flag });
  // };
  // const handle_Transfer_VisibleChange = (flag: any) => {
  //   setState({ ...state, isTransferPopup: flag });
  // };

  // const open_Mic_Speaker_Keyword = (status: string) => {
  //   if (status === 'mic') {
  //     setState({ ...state, open_ASR_mic: true });
  //   }
  //   else {
  //     setState({ ...state, open_ASR_speaker: true });
  //   }
  // };
  // const get_Default_Asrlanguage = () => {
  //   let language: any = _.find(ASR_Data.list, { languageCode: ast_default_Spe_Opt }) || [];
  //   return language?.languageName || 'english';
  // };
  const transcript_Open = () => {

        sendDTMF('*7')
     automatedMintsStore('transcript', 'callList', 'Transcription');
    // if (closeCaption.localStreaming === "stopped") {
    //   audioLanguageChange(ast_default_Mic_Opt, activeCallDetail.guid);
    // }
    // if (history.location.pathname !== 'calls') {
    //   history.push('/calls');
    //   setTimeout(function () {
    //     automatedMintsStore('transcript', 'callList', 'Transcription');
    //   }, 100)
    // }
    // else { automatedMintsStore('transcript', 'callList', 'Transcription'); }
  };

  const MOM_Open = () => {
    if (history.location.pathname !== 'calls') {
      history.push('/calls');
      setTimeout(function () { automatedMintsStore('summary', 'callList', 'MOM'); }, 100)
    }
    else { automatedMintsStore('summary', 'callList', 'MOM'); }
  };

  // const callEndFunction = () => {
  //   if (updatedCallRedux.length === 1) {
  //     toastShow('Call Ended', 1000);
  //     setTimeout(function () { currentCallEnd(); }, 1000);
  //   }
  //   else { currentCallEnd(); }
  // };

  let conferenceDetails = store.getState().conferenceDetails || [];
  let iconInfo = ['mute', 'keypad', 'addVideo', 'addCall', 'hold', 'recording', 'transfer', 'flip', 'park', 'transcript', 'mom', 'trancsribe'];
  let showIcon: any = iconInfo;
  if (updatedCallRedux.length === 2 && !activeCallDetail.consult) {
    showIcon = [];
  }
  else if (conferenceDetails.isConference && !conferenceDetails.isNewCall) {
    showIcon = ['mute', 'addCall'];
  }
  //storeDisable.indexOf('hold') !== -1 ? true :false


  const outPutLangSelection = (
    <>
      <div className={styles.autoTranslateLangs}>
        <span className={styles.topsecTxtTitle}>Record Spoken language</span>
        <div className={styles.searchBox}><URInput placeHolder='Search' className='searchBoxlanglist' /></div>
        <ul className={`scroller ${styles.langList}`}>
          <li className={styles.selected}><span className="icon_tick"></span> Global English (en) - default</li>
          <li><span className="icon_tick"></span> Spanish (es)</li>
          <li><span className="icon_tick"></span> French (fr)</li>
          <li><span className="icon_tick"></span> Portuguese (pt)</li>
          <li><span className="icon_tick"></span> Japanese (ja)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
          <li><span className="icon_tick"></span> Korean (ko)</li>
        </ul>
        <div className={`customchecksize ${styles.bottomFooterSec}`}>
          <URCheckBox /><span className={styles.saveTxttop}>Save for future</span>
        </div>
      </div>
    </>
  );


  const menu = (
    <Menu>
      <Menu.Item>ScreenShare</Menu.Item>
      {/* <Menu.Item onClick={showModal11}>Share</Menu.Item> */}
    </Menu>
  );
  
  let userData:any = frameCallProfile(getCurrentCallDetail()||{});
  let enableOptions:boolean=activeCallDetail.connectingStatus==='Attended'
  let con:boolean = false;
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  let groupContact:any=activeCallDetail?.groupCallInfo?.IndividualDetails;
  let pstncontact:any = activeCallDetail?.groupCallInfo?.PSTNDetails;
  let partLength:any = activeCallDetail?.groupCallInfo?.GroupDetails;
  const [keycount,setkeyCount] = useState(0);
  useEffect(() => {
      let connectedCount = 0;  
      Object.keys(partLength).forEach((gKey: any) => {
        const newKey: any = partLength[gKey];
        Object.keys(newKey).forEach((member: any) => {
          if (newKey[member].callStatus === 'Connected') {
            connectedCount++;
          }
        });
      });
      setkeyCount(connectedCount);
    }, [JSON.stringify(partLength),Object.keys(groupContact)?.length,JSON.stringify(activeCallDetail?.groupCallInfo)]);

      Object.keys(teamContacsnew).forEach((gKey: any) => {
        let newKey: any = teamContacsnew[gKey];
        Object.keys(newKey).forEach((member: any) => {
          if (((newKey['team_name']) === userData.combinedNames[0]))
          {
        con =true;
      } 
    });
  });

        var groupContactCount: number = Object.values(groupContact).filter((detail: any) => detail.callStatus === 'Connected' && detail.ext !== loggedUserDetails.ext).length;

          // Count the number of connected PSTNDetails
        var PSTNDetailsCount: number = Object.values(pstncontact).filter((detail: any) => detail.callStatus === 'Connected' && detail.ext !== loggedUserDetails.ext).length;

         // Add both counts together
         var newCount: number = groupContactCount + PSTNDetailsCount;
           // var newCount :any =Object.values(groupContact).filter((member: any) => member['callStatus'] === 'Connected' && member['ext'] !== loggedUserDetails.ext).length;
           const formattedNames = (userData?.combinedNames?.length === 0 || (userData?.combinedNames?.length === 1 && userData?.isGroupHost))?
           `${userData?.isHostId === loggedUserDetails?.ext.toString() ? `${userData?.combinedNames?.length < 1 ? "You" :userData?.callerName  }`:userData?.callerName} ${newCount > 0 ? `+ ${newCount} others`:''} `  : 
          (userData?.isHostId === loggedUserDetails?.ext.toString()) ? !con ? `You ${newCount > 0 ? `+ ${newCount} others`:''} ` :
          userData.combinedNames[0] +`${newCount > 0 ? `+ ${newCount} others`:''} ` :
          (userData?.isHostId !== loggedUserDetails?.ext.toString()) ?!con ? `${findCallHost(userData.isHostId)} ${keycount!==0 ?` + ${keycount} others` :
           newCount > 0 ? `+ ${ newCount} others`:''} `:userData.combinedNames[0]+(newCount > 0 ? ` + ${ newCount} others` : ''):
          `${findCallHost(userData.isHostId)} ${newCount > 0 ? `+ ${newCount} others`:''} ` ;
  return (
    
    <>

      {/* Team Call Code Stats */}
      <div className={styles.mainteamcall}>
        <div className={styles.teamcallinner}>
          <div className={styles.topflex}>
            <div className={styles.teamtoplayer}>
              {/* <URAvatarGroup className={`${`lefts size82 ${findTileSize(userData?.combinedNames)}`} ${styles.avatarname}`} profileInfo={ */}
              <URAvatarGroup className= {`lefts size82 colorBG2  ${(userData?.ImageURL !== null && userData?.ImageURL !== "")?'avatarWithImg':'' } ${styles.avatarname} `} profileInfo={
                !activeCallDetail.isGroupCall?(
                userData?.ImageURL !== "" ? <>
                <img src={userData?.ImageURL} alt="" />
              </>
                : <><span>{userData?.callerName?.charAt(0).toUpperCase()}</span>

                </>
                ):(
                  <>
                    { userData?.ImageURL?
                     <img src={userData?.ImageURL} alt="" />
                    :
                    //userTeamSplit
                    <span className="teamImgGroup"><img src={teamIcn} alt="team icon" /></span>
                   }
                  {/* {<>
                        {userData?.combinedNames?.length === 1 &&
                                            <span className="teamImg"><img src={teamIcn} alt="team icon" /></span>

                          //  <span>{(userData?.combinedNames[0])?.charAt(0).toUpperCase()}</span> 
                           }
                        {userData?.combinedNames?.length > 1 &&
                            <> <span>{userData?.combinedNames[0]?.charAt(0).toUpperCase()}</span>
                              <span>{userData?.combinedNames[1]?.charAt(0).toUpperCase()}</span></>}
                        {userData?.combinedNames?.length > 2 &&
                          <span>{userData?.combinedNames[2]?.charAt(0).toUpperCase()}</span>}
                        {userData?.combinedNames?.length > 3 &&
                          <span>{userData?.combinedNames[3]?.charAt(0).toUpperCase()}</span>}
                      </>} */}
                        {/* <span className="teamImg"><img src={teamIcn} alt="team icon" /></span> */}

                  </>
                )

              } />
              <h3 className={styles.groupNameDial}>{formattedNames}
               </h3>
              <p className={styles.timelength}>
                {userData?.connectingStatus === 'Attended' ? (altRecTimer(userData?.callduration)) : (userData?.connectingStatus)}
                <span className={styles.hd}>HD</span>
                {userData?.isHold && <span className={styles.hold}>On Hold</span>}
              </p>
              <CallMainWindowTeam></CallMainWindowTeam>
            </div>
          </div>

          <div className={styles.teambottomlayer}>
            <div className={styles.voiceMailOptions}>
              {/* <Tooltip placement="top" title="Mark as Unread"><div className={styles.readUNread}>
                      <div className={styles.unReaddot}></div>
                    </div></Tooltip> */}
              {/* <Tooltip placement="top" title="Automated Minutes ON"><div className={isActiveCheck === 'summary' ? `${styles.autoMatedMinutes} ${styles.selected}` : `${styles.autoMatedMinutes}`} onClick={MOM_Open}>
              </div></Tooltip> */}
              <Tooltip placement="top" title="Transcribe ON"><div className={!enableOptions ? ` ${styles.transcribe} ${styles.disable} ` : isActiveCheck === 'transcript' ? ` ${styles.transcribe} ${styles.selected} ` : `   ${styles.transcribe} `}
                onClick={transcript_Open}></div></Tooltip>
              {/* <Tooltip placement="top" title="Translation ON"><div className={styles.autoTranslate}>
                <div className={`${styles.translateSec}`}>
                  <Dropdown overlay={outPutLangSelection} placement="bottomRight" trigger={['click']}>
                    <div className={styles.langSelSec}>
                      <span className="icon_down-arrow"><div className={styles.langTooltip}>Language</div></span>
                    </div>
                  </Dropdown>
                </div>
                <div className={styles.inputLang}>Korean</div>
              </div></Tooltip> */}
              {/* <Tooltip placement="top" title="More">
                <Dropdown overlay={menu} placement="bottomRight" trigger={['click']}>
                  <div className={styles.moreAction}></div>
                </Dropdown>
              </Tooltip> */}
            </div>
          </div>
        </div>
      </div>
      {/* Team Call Code Ends Here */}

    </>
  );
}

export default DiallingWindow;


